// src/components/Sidebar.js
import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { logout } from "../store/session";

const Sidebar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Define the mobile sidebar open state
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(logout());
    localStorage.clear();
    navigate("/");
    setIsOpen(false);
  };

  // When a menu link is clicked, close the sidebar
  const handleLinkClick = () => {
    setIsOpen(false);
  };

  return (
    <>
      {/* Mobile Hamburger Icon (visible on mobile) */}
      <div className="lg:hidden fixed top-4 left-4 z-50">
        <button
          onClick={() => setIsOpen(true)}
          className="p-2 bg-white rounded-md shadow-md"
        >
          Menu
        </button>
      </div>

      {/* Mobile Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50 z-40"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`
          fixed top-0 left-0 h-full flex flex-col items-start 
          transition-all duration-300
          ${isOpen ? "w-[260px]" : "w-[80px] lg:w-[80px]"}
          lg:hover:w-[260px]
          bg-white bg-opacity-20 backdrop-blur-md 
          border-r border-gray-300  /* Thinner, lighter border */
          shadow-md             /* Subtle shadow */
          group z-50 overflow-hidden
        `}
      >
        <div className="h-14"></div>
        {/* Menu Items */}
        <ul className="flex flex-col space-y-6 w-full mt-4">
          {/* Devotions */}
          <li className="w-full">
            <NavLink
              to="/my-memos/devotions"
              onClick={handleLinkClick}
              className="flex items-center mx-3 py-2 px-3 rounded-md hover:bg-white hover:bg-opacity-70 cursor-pointer transition-all duration-300 w-full"
              activeclassname="bg-white bg-opacity-70"
            >
              <img
                src="/images/bookmark.png"
                alt="devotions"
                className="h-5 w-5 flex-shrink-0"
              />
              <span className="ml-4 text-black font-medium whitespace-nowrap hidden group-hover:inline-block">
                Devotions
              </span>
            </NavLink>
          </li>

          {/* Sunday Preparation */}
          <li className="w-full">
            <NavLink
              to="/devotions/sunday"
              onClick={handleLinkClick}
              className="flex items-center mx-3 py-2 px-3 rounded-md hover:bg-white hover:bg-opacity-70 cursor-pointer transition-all duration-300 w-full"
              activeclassname="bg-white bg-opacity-70"
            >
              <img
                src="/images/speech.png"
                alt="sunday preparation"
                className="h-5 w-5 flex-shrink-0"
              />
              <span className="ml-4 text-black font-medium whitespace-nowrap hidden group-hover:inline-block">
                Sunday Prep
              </span>
            </NavLink>
          </li>

          {/* Notes */}
          <li className="w-full">
            <NavLink
              to="/my-memos/memos"
              onClick={handleLinkClick}
              className="flex items-center mx-3 py-2 px-3 rounded-md hover:bg-white hover:bg-opacity-70 cursor-pointer transition-all duration-300 w-full"
              activeclassname="bg-white bg-opacity-70"
            >
              <img
                src="/images/notes.png"
                alt="notes"
                className="h-5 w-5 flex-shrink-0"
              />
              <span className="ml-4 text-black font-medium whitespace-nowrap hidden group-hover:inline-block">
                Notes
              </span>
            </NavLink>
          </li>

          {/* Highlights */}
          <li className="w-full">
            <NavLink
              to="/my-memos/highlights"
              onClick={handleLinkClick}
              className="flex items-center mx-3 py-2 px-3 rounded-md hover:bg-white hover:bg-opacity-70 cursor-pointer transition-all duration-300 w-full"
              activeclassname="bg-white bg-opacity-70"
            >
              <img
                src="/images/highlighter.png"
                alt="highlighter"
                className="h-6 w-6 flex-shrink-0"
              />
              <span className="ml-4 text-black font-medium whitespace-nowrap hidden group-hover:inline-block">
                Highlights
              </span>
            </NavLink>
          </li>

          {/* Sermons */}
          <li className="w-full">
            <NavLink
              to="/my-memos/sermons"
              onClick={handleLinkClick}
              className="flex items-center mx-3 py-2 px-3 rounded-md hover:bg-white hover:bg-opacity-70 cursor-pointer transition-all duration-300 w-full"
              activeclassname="bg-white bg-opacity-70"
            >
              <img
                src="/images/sermon.png"
                alt="sermon"
                className="h-5 w-5 flex-shrink-0"
              />
              <span className="ml-4 text-black font-medium whitespace-nowrap hidden group-hover:inline-block">
                Sermons
              </span>
            </NavLink>
          </li>

          <hr className="border-gray-300 my-4 w-full" />

          {/* Logout */}
          <li className="w-full">
            <button
              onClick={handleLogout}
              className="flex items-center mx-3 py-2 px-4 rounded-md hover:bg-white hover:bg-opacity-70 cursor-pointer transition-all duration-300 w-full"
            >
              <img
                src="/images/log-out.png"
                alt="log-out"
                className="h-5 w-5 flex-shrink-0"
              />
              <span className="ml-4 text-black font-medium whitespace-nowrap hidden group-hover:inline-block">
                Logout
              </span>
            </button>
          </li>
        </ul>
      </aside>
    </>
  );
};

export default Sidebar;
